import React from "react";
import CareerWithAptechSection from "../components/CareersWithAptech/CareerWithAptech.tsx";
import MetaComponent from "../components/CommonComponents/MetaComponent.tsx";
const CareerWithAptech =()=>{

    return(
        <div>
             <MetaComponent
        title="Explore Exciting Careers at Aptech - Explore Roles in IT, Marketing, and Training"
        desc="Explore career opportunities with Aptech, a pioneer in vocational skill training. Discover roles in sales, marketing, IT, corporate training, and more!"
        keywords="vocational training, career with aptech, job openings"
      />
            <CareerWithAptechSection />
        </div>
    )
}

export default CareerWithAptech;